import script from "./SessionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionCard.vue?vue&type=script&setup=true&lang=js"

import "./SessionCard.vue?vue&type=style&index=0&id=31d3db81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d3db81"]])

export default __exports__